<div class="wrapper">
  <ng-template [ngIf]="!showIcon">
    <ng-container *ngIf="isImage">
      <img style="width: 100%" [src]="item.file" />
    </ng-container>
    <ng-container *ngIf="isPdf">
      <canvas id="canvasEl"></canvas>
    </ng-container>
    <div class="overlay">
      <span class="overlay-title">
        {{ item.description ? item.description : title }}
      </span>
      <sn-icon-button
        (click)="download()"
        [matTooltip]="'common.download' | t"
        matTooltipPosition="below"
        color="success"
        icon="get_app"
      >
      </sn-icon-button>
      <sn-icon-button
        *ngIf="canDelete"
        (click)="deleteItem()"
        [matTooltip]="'common.delete' | t"
        matTooltipPosition="below"
        color="danger"
        icon="delete"
      >
      </sn-icon-button>
    </div>
  </ng-template>
  <ng-template [ngIf]="showIcon">
    <div class="fs-container">
      <div class="title-container">
        <span class="title">
          {{ item.description ? item.description : title }}
        </span>
        <sn-icon class="file-icon" fontSet="fa" fontIcon="fa-file"></sn-icon>
        <sn-icon-button
          (click)="download()"
          [matTooltip]="'common.download' | t"
          matTooltipPosition="below"
          color="success"
          icon="get_app"
        >
        </sn-icon-button>
        <sn-icon-button
          *ngIf="canDelete"
          (click)="deleteItem()"
          [matTooltip]="'common.delete' | t"
          matTooltipPosition="below"
          color="danger"
          icon="delete"
        >
        </sn-icon-button>
      </div>
    </div>
  </ng-template>
</div>
